/*! Copyright 2026 Fonticons, Inc. - https://webawesome.com/license */
import {
  WaOptionsErrorEvent
} from "./chunk.FAJO7SGN.js";
import {
  WaOptionsRequestEvent
} from "./chunk.WFX7RSWY.js";
import {
  WaCreateEvent
} from "./chunk.WFODKN2M.js";
import {
  scrollIntoView
} from "./chunk.YIGH2OYQ.js";
import {
  announce
} from "./chunk.ABTEE2GJ.js";
import {
  WaShowEvent
} from "./chunk.OCXPLMDW.js";
import {
  WaHideEvent
} from "./chunk.ADZNIDEZ.js";
import {
  WaAfterHideEvent
} from "./chunk.IXFCHTNQ.js";
import {
  WaAfterShowEvent
} from "./chunk.HOKX4ZNE.js";
import {
  o as o3
} from "./chunk.2BXLTQVW.js";
import {
  WaClearEvent
} from "./chunk.V6242M3W.js";
import {
  isTopDismissible,
  registerDismissible,
  unregisterDismissible
} from "./chunk.H5UCAMJQ.js";
import {
  RequiredValidator
} from "./chunk.X73BGBMJ.js";
import {
  form_control_styles_default
} from "./chunk.WWLUKDGE.js";
import {
  combobox_styles_default
} from "./chunk.TV4AOM67.js";
import {
  WebAwesomeFormAssociatedElement
} from "./chunk.WPF5VWVD.js";
import {
  warnDeprecatedSize
} from "./chunk.7TN7YXGH.js";
import {
  HasSlotController
} from "./chunk.5FXMXJDZ.js";
import {
  size_styles_default
} from "./chunk.YO5ITST6.js";
import {
  o as o2
} from "./chunk.3MSWQ3RG.js";
import {
  waitForEvent
} from "./chunk.572W6XBT.js";
import {
  animateWithClass
} from "./chunk.ZRLIH7NU.js";
import {
  e as e2
} from "./chunk.KWDPKKFO.js";
import {
  watch
} from "./chunk.U7CMGUQU.js";
import {
  e,
  n,
  r,
  t
} from "./chunk.2S7VPMOT.js";
import {
  LocalizeController
} from "./chunk.MDUIT7N7.js";
import {
  o
} from "./chunk.E4Q7ZNYW.js";
import {
  E,
  x
} from "./chunk.BKE5EYM3.js";
import {
  __decorateClass
} from "./chunk.7F23ACLI.js";

// _bundle_/src/components/combobox/combobox.ts
var listboxIdCounter = 0;
var LOADING_ANNOUNCE_DELAY = 1e3;
var STAND_IN_ATTRIBUTE = "data-retained-option";
var WaCombobox = class extends WebAwesomeFormAssociatedElement {
  constructor() {
    super(...arguments);
    this.assumeInteractionOn = ["blur", "input"];
    this.createOptionEl = null;
    this.hasInputSinceOpening = false;
    this.hasSlotController = new HasSlotController(this, "hint", "label");
    this.localize = new LocalizeController(this);
    this.listboxId = `wa-combobox-listbox-${++listboxIdCounter}`;
    this.selectionOrder = /* @__PURE__ */ new Map();
    this.slotChangePending = false;
    this.cachedOptions = null;
    //
    // Server (async) options
    //
    /** Aborts the in-flight request. Recreated per request. */
    this.abortController = null;
    /** Monotonically increasing; a response whose token isn't current is a stale, out-of-order arrival. */
    this.requestToken = 0;
    /** The query of the in-flight or last-applied request, used to skip echoes of a request already made. */
    this.lastRequestedQuery = null;
    this.hasRequestError = false;
    /** True while an IME composition is active; requests wait for `compositionend`. */
    this.isComposing = false;
    /** The markup each showing result arrived with, so a response that repeats it can leave the listbox alone. */
    this.appliedMarkup = [];
    this.selectedOptions = [];
    this.filteredOptions = [];
    this.inputValue = "";
    this.name = "";
    this._defaultValue = null;
    this.size = "m";
    this.placeholder = "";
    this.multiple = false;
    this.maxOptionsVisible = 3;
    this.disabled = false;
    this.withClear = false;
    this.open = false;
    this.appearance = "outlined";
    this.pill = false;
    this.label = "";
    this.placement = "bottom";
    this.hint = "";
    this.withLabel = false;
    this.withHint = false;
    this.required = false;
    this.allowCustomValue = false;
    this.allowCreate = false;
    this.filter = null;
    this.dataSource = null;
    this.server = false;
    this.loading = false;
    this.filterDebounce = 250;
    this.spellcheck = false;
    this.getTag = (option) => {
      return x`
        <wa-tag
          part="tag"
          exportparts="
            base:tag__base,
            content:tag__content,
            remove-button:tag__remove-button,
            remove-button__base:tag__remove-button__base
          "
          ?pill=${this.pill}
          size=${this.size}
          with-remove
          data-value=${option.value}
          @wa-remove=${(event) => this.handleTagRemove(event, option)}
        >
          ${option.label}
        </wa-tag>
      `;
    };
    this.handleDocumentFocusIn = (event) => {
      const path = event.composedPath();
      if (this && !path.includes(this)) {
        this.hide();
      }
    };
    this.handleDocumentKeyDown = (event) => {
      const target = event.target;
      const isClearButton = target.closest('[part~="clear-button"]') !== null;
      const isButton = target.closest("wa-button") !== null;
      if (isClearButton || isButton) {
        return;
      }
      if (event.key === "Escape" && this.open && isTopDismissible(this)) {
        event.preventDefault();
        event.stopPropagation();
        this.hide();
        if (!this.multiple && this.selectedOptions.length > 0) {
          this.inputValue = this.selectedOptions[0].label;
        } else if (!this.multiple) {
          this.inputValue = "";
        }
        this.comboboxInput.focus({ preventScroll: true });
        return;
      }
      if (event.key === "Enter") {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!this.open) {
          this.show();
          return;
        }
        if (this.currentOption && this.handleCreateOptionSelected(this.currentOption)) {
          return;
        }
        const currentOption = this.currentOption;
        if (currentOption) {
          this.valueHasChanged = true;
          this.hasInteracted = true;
          if (this.multiple) {
            this.toggleOptionSelection(currentOption);
            this.inputValue = "";
            this.updateFilteredOptions();
          } else {
            this.setSelectedOptions(currentOption);
            this.inputValue = currentOption.label;
          }
          this.updateComplete.then(() => {
            this.dispatchEvent(new InputEvent("input", { bubbles: true, composed: true }));
            this.dispatchEvent(new Event("change", { bubbles: true, composed: true }));
          });
          if (!this.multiple) {
            this.hide();
            this.comboboxInput.focus({ preventScroll: true });
          }
        } else if (this.allowCustomValue && !this.multiple && this.inputValue) {
          this.value = this.inputValue;
          this.valueHasChanged = true;
          this.hasInteracted = true;
          this.updateComplete.then(() => {
            this.dispatchEvent(new InputEvent("input", { bubbles: true, composed: true }));
            this.dispatchEvent(new Event("change", { bubbles: true, composed: true }));
          });
          this.hide();
          this.comboboxInput.focus({ preventScroll: true });
        }
        return;
      }
      if (event.key === "Backspace" && this.multiple && !this.inputValue && this.selectedOptions.length > 0) {
        event.preventDefault();
        this.hasInteracted = true;
        this.valueHasChanged = true;
        const lastOption = this.selectedOptions[this.selectedOptions.length - 1];
        this.toggleOptionSelection(lastOption, false);
        this.updateComplete.then(() => {
          this.dispatchEvent(new InputEvent("input", { bubbles: true, composed: true }));
          this.dispatchEvent(new Event("change", { bubbles: true, composed: true }));
        });
        return;
      }
      if (["ArrowUp", "ArrowDown", "Home", "End"].includes(event.key)) {
        const visibleOptions = this.getVisibleOptions();
        const currentIndex = this.currentOption ? visibleOptions.indexOf(this.currentOption) : -1;
        let newIndex = Math.max(0, currentIndex);
        event.preventDefault();
        if (!this.open) {
          this.show();
          if (this.currentOption) {
            return;
          }
        }
        if (visibleOptions.length === 0) {
          return;
        }
        if (event.key === "ArrowDown") {
          newIndex = currentIndex + 1;
          if (newIndex > visibleOptions.length - 1) newIndex = 0;
        } else if (event.key === "ArrowUp") {
          newIndex = currentIndex - 1;
          if (newIndex < 0) newIndex = visibleOptions.length - 1;
        } else if (event.key === "Home") {
          newIndex = 0;
        } else if (event.key === "End") {
          newIndex = visibleOptions.length - 1;
        }
        if (visibleOptions[newIndex]) {
          this.setCurrentOption(visibleOptions[newIndex]);
          this.announceOption(visibleOptions[newIndex]);
        }
      }
    };
    this.handleDocumentMouseDown = (event) => {
      const path = event.composedPath();
      if (this && !path.includes(this)) {
        this.hide();
      }
    };
  }
  static get validators() {
    const validators = o ? [] : [
      RequiredValidator({
        validationElement: Object.assign(document.createElement("select"), { required: true })
      })
    ];
    return [...super.validators, ...validators];
  }
  rawValuesEqual(a, b) {
    if (a == null && b == null) return true;
    if (a == null || b == null) return false;
    if (a.length !== b.length) return false;
    return a.every((v, i) => v === b[i]);
  }
  /** Where to anchor native constraint validation */
  get validationTarget() {
    return this.valueInput;
  }
  /**
   * The option the user is keying through, or `undefined` once it's unusable. In server mode a response or a consumer
   * swap can remove or hide the highlighted option at any moment, and no reader — Enter above all — may act on it.
   */
  get currentOption() {
    const option = this._currentOption;
    return option?.isConnected && !option.hidden && !option.disabled ? option : void 0;
  }
  set currentOption(option) {
    this._currentOption = option;
  }
  set defaultValue(val) {
    this._defaultValue = this.convertDefaultValue(val);
  }
  get defaultValue() {
    return this.convertDefaultValue(this._defaultValue);
  }
  /**
   * A converter for defaultValue from array to string if its multiple. Also fixes some hydration issues.
   */
  convertDefaultValue(val) {
    const isMultiple = this.multiple || this.hasAttribute("multiple");
    if (!isMultiple && Array.isArray(val)) {
      val = val[0];
    }
    return val;
  }
  set value(val) {
    let oldValue = this.value;
    if (val instanceof FormData) {
      val = val.getAll(this.name);
    }
    if (val != null && !Array.isArray(val)) {
      val = [val];
    }
    const oldRawValue = this._value;
    this._value = val ?? null;
    if (!this.rawValuesEqual(oldRawValue, this._value)) {
      this.valueHasChanged = true;
      this.requestUpdate("value", oldValue);
    }
  }
  get value() {
    let value = this._value ?? this.defaultValue ?? null;
    if (value != null) {
      value = Array.isArray(value) ? value : [value];
    }
    this.optionValues = new Set(
      this.getRealOptions().filter((option) => !option.disabled).map((option) => option.value)
    );
    let ret = value;
    if (value != null) {
      if (!this.allowCustomValue) {
        ret = value.filter((v) => this.optionValues.has(v));
      } else {
        ret = value;
      }
      ret = this.multiple ? ret : ret[0];
      ret = ret ?? null;
    }
    return ret;
  }
  handleSizeChange() {
    warnDeprecatedSize(this.localName, this.size);
  }
  connectedCallback() {
    super.connectedCallback();
    this.processSlotChange();
    this.open = false;
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeOpenListeners();
    this.removeCreateOption();
    this.cancelOptionsRequest();
    this.cachedOptions = null;
  }
  /**
   * @internal
   */
  updateFormValue(value) {
    if (value == null) {
      this.setValue("", null);
      return;
    }
    super.updateFormValue(value);
  }
  updateDefaultValue() {
    const allOptions = this.getRealOptions();
    const defaultSelectedOptions = allOptions.filter((el) => el.hasAttribute("selected") || el.defaultSelected);
    if (defaultSelectedOptions.length > 0) {
      const selectedValues = defaultSelectedOptions.map((el) => el.value);
      this._defaultValue = this.multiple ? selectedValues : selectedValues[0];
    }
    if (this.hasAttribute("value")) {
      this._defaultValue = this.getAttribute("value") || null;
    }
  }
  addOpenListeners() {
    document.addEventListener("focusin", this.handleDocumentFocusIn);
    document.addEventListener("keydown", this.handleDocumentKeyDown);
    document.addEventListener("mousedown", this.handleDocumentMouseDown);
    registerDismissible(this);
    if (this.getRootNode() !== document) {
      this.getRootNode().addEventListener("focusin", this.handleDocumentFocusIn);
    }
  }
  removeOpenListeners() {
    document.removeEventListener("focusin", this.handleDocumentFocusIn);
    document.removeEventListener("keydown", this.handleDocumentKeyDown);
    document.removeEventListener("mousedown", this.handleDocumentMouseDown);
    unregisterDismissible(this);
    if (this.getRootNode() !== document) {
      this.getRootNode().removeEventListener("focusin", this.handleDocumentFocusIn);
    }
  }
  handleFocus() {
    this.comboboxInput.select();
  }
  handleBlur() {
    if (!this.multiple) {
      if (!this.inputValue) {
        if (this.value !== null) {
          this.selectionOrder.clear();
          this.setSelectedOptions([]);
          this.hasInteracted = true;
          this.valueHasChanged = true;
          this.updateComplete.then(() => {
            this.dispatchEvent(new InputEvent("input", { bubbles: true, composed: true }));
            this.dispatchEvent(new Event("change", { bubbles: true, composed: true }));
          });
        }
      } else if (this.allowCustomValue) {
        const previousValue = this.value;
        this.value = this.inputValue;
        this.hasInteracted = true;
        if (this.value !== previousValue) {
          this.valueHasChanged = true;
          this.updateComplete.then(() => {
            this.dispatchEvent(new Event("change", { bubbles: true, composed: true }));
          });
        }
      } else if (this.selectedOptions.length > 0) {
        this.inputValue = this.selectedOptions[0].label;
      }
    }
    if (!this.open) {
      this.removeCreateOption();
      this.cancelOptionsRequest();
    }
  }
  handleLabelClick() {
    this.comboboxInput.focus();
    this.show();
  }
  handleComboboxClick(event) {
    event.preventDefault();
  }
  handleComboboxMouseDown(event) {
    const path = event.composedPath();
    const isButton = path.some((el) => el instanceof Element && el.tagName.toLowerCase() === "wa-button");
    if (this.disabled || isButton) {
      return;
    }
    event.preventDefault();
    this.comboboxInput.focus({ preventScroll: true });
    this.open = !this.open;
  }
  handleComboboxKeyDown(event) {
    event.stopPropagation();
    this.handleDocumentKeyDown(event);
  }
  handleCompositionStart() {
    this.isComposing = true;
  }
  handleCompositionEnd() {
    this.isComposing = false;
    if (this.isServerMode) {
      this.requestOptions({ debounce: true });
    }
  }
  handleInputChange(event) {
    event.stopPropagation();
    const input = event.target;
    this.inputValue = input.value;
    this.hasInputSinceOpening = true;
    this.dispatchEvent(new InputEvent("input", { bubbles: true, composed: true }));
    this.updateFilteredOptions();
    const visibleOptions = this.getVisibleOptions();
    const hasVisibleOptions = visibleOptions.length > 0;
    if (this.isServerMode) {
      if (this.inputValue && !this.open && !this.allowCustomValue) {
        void this.show();
      }
      this.setCurrentOption(null);
      this.requestOptions({ debounce: true });
    } else {
      if (this.inputValue.length > 0 && !this.open) {
        if (hasVisibleOptions || !this.allowCustomValue || this.loading) {
          void this.show();
        }
      } else if (this.open && !hasVisibleOptions && this.allowCustomValue && !this.loading) {
        void this.hide();
      }
      if (hasVisibleOptions && this.open) {
        this.setCurrentOption(visibleOptions[0]);
      }
    }
    this.announceFilterResults();
    if (!this.isServerMode && this.open && this.currentOption) {
      this.announceOption(this.currentOption);
    }
  }
  handleClearClick(event) {
    event.stopPropagation();
    this.hasInteracted = true;
    if (this.value !== null || this.inputValue) {
      this.selectionOrder.clear();
      this.setSelectedOptions([]);
      this.inputValue = "";
      this.updateFilteredOptions();
      this.comboboxInput.focus({ preventScroll: true });
      this.updateComplete.then(() => {
        this.dispatchEvent(new WaClearEvent());
        this.dispatchEvent(new InputEvent("input", { bubbles: true, composed: true }));
        this.dispatchEvent(new Event("change", { bubbles: true, composed: true }));
      });
    }
  }
  handleClearMouseDown(event) {
    event.stopPropagation();
    event.preventDefault();
  }
  handleOptionClick(event) {
    const target = event.target;
    const option = target.closest("wa-option");
    if (option && !option.disabled) {
      if (this.handleCreateOptionSelected(option)) {
        this.updateComplete.then(() => this.comboboxInput.focus({ preventScroll: true }));
        return;
      }
      this.hasInteracted = true;
      this.valueHasChanged = true;
      if (this.multiple) {
        this.toggleOptionSelection(option);
        this.inputValue = "";
        this.updateFilteredOptions();
      } else {
        this.setSelectedOptions(option);
        this.inputValue = option.label;
      }
      this.updateComplete.then(() => this.comboboxInput.focus({ preventScroll: true }));
      this.requestUpdate("value");
      this.updateComplete.then(() => {
        this.dispatchEvent(new InputEvent("input", { bubbles: true, composed: true }));
        this.dispatchEvent(new Event("change", { bubbles: true, composed: true }));
      });
      if (!this.multiple) {
        this.hide();
        this.comboboxInput.focus({ preventScroll: true });
      }
    }
  }
  /* @internal - used by options to update labels */
  handleDefaultSlotChange() {
    if (this.slotChangePending) return;
    this.slotChangePending = true;
    queueMicrotask(() => {
      this.slotChangePending = false;
      this.processSlotChange();
    });
  }
  processSlotChange() {
    if (!this.querySelectorAll) {
      return;
    }
    if (!customElements.get("wa-option")) {
      customElements.whenDefined?.("wa-option").then(() => this.handleDefaultSlotChange());
      return;
    }
    const previouslySelected = this.selectedOptions;
    this.cachedOptions = null;
    this.retainSelections(previouslySelected);
    this.updateDefaultValue();
    let value = this.value;
    if (value == null || !this.valueHasChanged && !this.hasInteracted) {
      this.pruneStandIns();
      this.selectionChanged();
    } else {
      if (!Array.isArray(value)) {
        value = [value];
      }
      const values = value;
      this.setSelectedOptions(this.getAllOptions().filter((el) => values.includes(el.value)));
    }
    if (!this.open) {
      this.updateFilteredOptions({ skipCreateOption: true });
    }
    if (this.isServerMode && !this.dataSource && this.open && !this.loading && !this.currentOption) {
      this.finishOptionsChange();
    }
  }
  handleTagRemove(event, directOption) {
    event.stopPropagation();
    if (this.disabled) return;
    this.hasInteracted = true;
    this.valueHasChanged = true;
    let option = directOption;
    if (!option) {
      const tagElement = event.target.closest("wa-tag[data-value]");
      if (tagElement) {
        const value = tagElement.dataset.value;
        option = this.selectedOptions.find((opt) => opt.value === value);
      }
    }
    if (option) {
      this.toggleOptionSelection(option, false);
      this.updateComplete.then(() => {
        this.dispatchEvent(new InputEvent("input", { bubbles: true, composed: true }));
        this.dispatchEvent(new Event("change", { bubbles: true, composed: true }));
      });
    }
  }
  // Gets an array of all `<wa-option>` elements
  getAllOptions() {
    if (this.cachedOptions) return this.cachedOptions;
    if (!this?.querySelectorAll) {
      return [];
    }
    this.cachedOptions = [...this.querySelectorAll("wa-option")];
    return this.cachedOptions;
  }
  // Gets all options excluding the synthetic create option
  getRealOptions() {
    return this.getAllOptions().filter((o4) => !o4.hasAttribute("data-create-option"));
  }
  //
  // Server (async) mode
  //
  /** True when options come from a server, either via `dataSource` or via `wa-options-request`. */
  get isServerMode() {
    return this.server || this.dataSource !== null;
  }
  /** The text the user has typed since opening. A selected option's label sitting in the input is never a query. */
  get currentQuery() {
    return this.hasInputSinceOpening ? this.inputValue : "";
  }
  /**
   * Schedules a request for options. `debounce` waits `filterDebounce` ms (typing); opening and `reload()` go
   * immediately. `force` bypasses the dedupe check so a repeat of the last query still refetches.
   */
  requestOptions({ debounce = false, force = false } = {}) {
    if (!this.isServerMode || o || !this.isConnected || this.disabled) return;
    if (this.isComposing) return;
    if (!force && this.currentQuery === this.lastRequestedQuery) return;
    clearTimeout(this.debounceTimer);
    this.loading = true;
    if (debounce && this.filterDebounce > 0) {
      this.debounceTimer = setTimeout(() => void this.sendRequest(), this.filterDebounce);
      return;
    }
    return this.sendRequest();
  }
  /**
   * Sends the request. Aborts whatever was in flight, emits `wa-options-request`, and — with a `dataSource` — applies
   * the response. A monotonic token drops out-of-order arrivals.
   */
  async sendRequest() {
    if (!this.isServerMode || o || !this.isConnected) return;
    const query = this.currentQuery;
    this.lastRequestedQuery = query;
    this.hasRequestError = false;
    this.abortController?.abort();
    const controller = new AbortController();
    this.abortController = controller;
    const token = ++this.requestToken;
    this.loading = true;
    clearTimeout(this.loadingAnnounceTimer);
    this.loadingAnnounceTimer = setTimeout(() => {
      if (this.loading) this.announce(this.localize.term("loading"));
    }, LOADING_ANNOUNCE_DELAY);
    const request = { query, signal: controller.signal };
    this.dispatchEvent(new WaOptionsRequestEvent(request));
    if (!this.dataSource) return;
    let nodes = [];
    try {
      nodes = this.toElements(await this.dataSource(request));
    } catch (error) {
      if (token !== this.requestToken || controller.signal.aborted) return;
      this.hasRequestError = true;
      this.lastRequestedQuery = null;
      this.dispatchEvent(new WaOptionsErrorEvent({ error, request: { query } }));
      console.error("<wa-combobox> dataSource request failed:", error);
    }
    if (token !== this.requestToken) return;
    this.loading = false;
    clearTimeout(this.loadingAnnounceTimer);
    this.applyOptions(nodes);
  }
  /**
   * Re-requests options using the current query (or an empty query when the listbox is closed). Resolves once the
   * response has been applied in `dataSource` mode, or immediately after `wa-options-request` is emitted in event
   * mode, so `await combobox.reload()` followed by setting `value` works.
   */
  async reload() {
    if (!this.isServerMode) return;
    await this.requestOptions({ force: true });
  }
  /** Aborts any pending or in-flight request and stops reporting as busy. Never touches the options already applied. */
  cancelOptionsRequest() {
    clearTimeout(this.debounceTimer);
    clearTimeout(this.loadingAnnounceTimer);
    this.abortController?.abort();
    this.abortController = null;
    this.requestToken++;
    this.lastRequestedQuery = null;
    this.loading = false;
  }
  /** Turns a `dataSource` response into elements. HTML is parsed in an inert template, so nothing runs until adopted. */
  toElements(response) {
    if (typeof response === "string") {
      const template = document.createElement("template");
      template.innerHTML = response;
      return [...template.content.children].filter(
        (node) => node instanceof HTMLElement && node.localName !== "script"
      );
    }
    if (!Array.isArray(response)) {
      throw new TypeError(
        "A dataSource must resolve with an array of { value, label } objects, a string of HTML, or an array of elements."
      );
    }
    return response.map((item) => {
      if (item instanceof HTMLElement) return item;
      const option = document.createElement("wa-option");
      option.setAttribute("value", String(item.value));
      option.textContent = item.label ?? "";
      option.toggleAttribute("disabled", item.disabled === true);
      return option;
    });
  }
  /**
   * Replaces the options with a response. The response's nodes are appended in order, deduped by value, and the
   * selection carries across by value: a selected value the response omits is parked in a hidden stand-in so `value`
   * and the tags survive. The create option and existing stand-ins are left alone.
   */
  applyOptions(nodes) {
    const seen = /* @__PURE__ */ new Set();
    const incoming = [];
    for (const node of nodes) {
      if (node.localName === "wa-option") {
        const value = node.getAttribute("value");
        if (!value || seen.has(value)) {
          console.warn(
            `<wa-combobox> ignored a dataSource option with ${value ? `a duplicate value "${value}"` : "no value"}.`
          );
          continue;
        }
        seen.add(value);
      } else if (node.localName === "wa-divider") {
        node.setAttribute("aria-hidden", "true");
      } else if (!node.hasAttribute("role")) {
        node.setAttribute("role", "presentation");
      }
      incoming.push(node);
    }
    const showing = [...this.children].filter(
      (child) => !child.hasAttribute("slot") && child !== this.createOptionEl && !child.hasAttribute(STAND_IN_ATTRIBUTE)
    );
    const markup = incoming.map((node) => node.outerHTML);
    const unchanged = incoming.length === showing.length && incoming.every((node, index) => node === showing[index] || markup[index] === this.appliedMarkup[index]);
    this.appliedMarkup = markup;
    if (unchanged) {
      this.finishOptionsChange();
      return;
    }
    const previouslySelected = this.selectedOptions;
    const previousCurrentValue = this._currentOption?.value ?? null;
    for (const child of showing) child.remove();
    for (const node of incoming) this.appendChild(node);
    this.cachedOptions = null;
    for (const option of this.getRealOptions()) {
      if (previouslySelected.some((previous) => previous.value === option.value)) {
        option.selected = true;
        option.setAttribute("aria-selected", "true");
      }
    }
    this.retainSelections(previouslySelected);
    this.pruneStandIns();
    this.selectionChanged();
    this.finishOptionsChange(previousCurrentValue);
  }
  /**
   * Keeps a selection alive when the options backing it leave the DOM — a response that omits a selected value, or a
   * consumer swapping the children in event mode. Each such value gets a hidden, selected stand-in carrying its label.
   * We insert our own node rather than re-appending the consumer's, which frameworks own.
   */
  retainSelections(previouslySelected) {
    if (!this.isServerMode || o) return;
    const present = new Set(this.getRealOptions().map((option) => option.value));
    for (const previous of previouslySelected) {
      if (present.has(previous.value)) continue;
      const standIn = document.createElement("wa-option");
      standIn.setAttribute(STAND_IN_ATTRIBUTE, "");
      standIn.value = previous.value;
      standIn.textContent = previous.label;
      standIn.hidden = true;
      standIn.selected = true;
      this.appendChild(standIn);
      present.add(previous.value);
      this.cachedOptions = null;
    }
  }
  /** Retires stand-ins that are no longer selected or whose real option is back, handing the selection over to it. */
  pruneStandIns() {
    const options = this.getAllOptions();
    for (const standIn of options) {
      if (!standIn.hasAttribute(STAND_IN_ATTRIBUTE)) continue;
      const real = options.find((option) => option.value === standIn.value && !option.hasAttribute(STAND_IN_ATTRIBUTE));
      if (real && standIn.selected) real.selected = true;
      if (real || !standIn.selected) {
        standIn.remove();
        this.cachedOptions = null;
      }
    }
  }
  /**
   * Settles the component once the options change in server mode, for both the callback and event paths: refresh the
   * visible set, announce the result, re-pick the current option, and let the result open or close the listbox.
   */
  finishOptionsChange(previousCurrentValue = this._currentOption?.value ?? null) {
    this.updateFilteredOptions();
    this.announceFilterResults();
    this.reseatCurrentOption(previousCurrentValue);
    this.syncOpenStateAfterResponse();
    this.requestUpdate();
  }
  /**
   * Picks the current option once a fresh set is in place. Typed since opening → the first result; otherwise the option
   * with the previous highlight's value (element identity isn't stable across a response), else a selected option,
   * else the first result. Speaks the landing option when the highlight actually moved.
   */
  reseatCurrentOption(previousValue) {
    if (!this.open) {
      this.setCurrentOption(null);
      return;
    }
    const visible = this.getVisibleOptions();
    const next = this.hasInputSinceOpening ? visible[0] : visible.find((option) => option.value === previousValue) ?? visible.find((option) => option.selected) ?? visible[0];
    this.setCurrentOption(next ?? null);
    if (next && next.value !== previousValue) this.announceOption(next);
  }
  /**
   * Opens or closes the listbox once a response lands, for server mode with `allow-custom-value`. Free-text entry
   * can't open eagerly ("no results" for text the user is inventing) or close eagerly (flicker on every keystroke),
   * so typing leaves the listbox as-is and the response decides. An error row stays put so it can be read.
   */
  syncOpenStateAfterResponse() {
    if (!this.isServerMode || !this.allowCustomValue || !this.hasInputSinceOpening || this.hasRequestError) return;
    const hasVisibleOptions = this.getVisibleOptions().length > 0;
    if (!this.open) {
      if (hasVisibleOptions && this.matches(":focus-within")) void this.show();
    } else if (!hasVisibleOptions && this.currentQuery && !this.loading) {
      void this.hide();
    }
  }
  // Creates, updates, or removes the synthetic "Create X" option based on current input
  updateCreateOption() {
    if (!this.allowCreate) {
      this.removeCreateOption();
      return;
    }
    const query = this.inputValue.trim();
    const allRealOptions = this.getRealOptions();
    const exactMatch = allRealOptions.some((option) => option.label.toLowerCase() === query.toLowerCase());
    if (query && !exactMatch) {
      if (!this.createOptionEl) {
        this.createOptionEl = document.createElement("wa-option");
        this.createOptionEl.setAttribute("data-create-option", "");
      }
      this.createOptionEl.value = query;
      this.createOptionEl.textContent = this.localize.term("createOption", query);
      this.createOptionEl.hidden = false;
      if (this.createOptionEl.parentElement !== this) {
        this.prepend(this.createOptionEl);
      }
    } else {
      this.removeCreateOption();
    }
  }
  removeCreateOption() {
    if (this.createOptionEl) {
      this.createOptionEl.remove();
      this.createOptionEl = null;
    }
  }
  // Handles selection of the synthetic create option. Returns true if it was a create option.
  handleCreateOptionSelected(option) {
    if (!option.hasAttribute("data-create-option")) {
      return false;
    }
    const inputValue = this.createOptionEl?.value || this.inputValue.trim();
    const createEvent = new WaCreateEvent({ inputValue });
    this.dispatchEvent(createEvent);
    if (createEvent.defaultPrevented) {
      this.removeCreateOption();
      return true;
    }
    this.removeCreateOption();
    const newOption = document.createElement("wa-option");
    newOption.value = inputValue;
    newOption.textContent = inputValue;
    this.prepend(newOption);
    this.cachedOptions = null;
    this.hasInteracted = true;
    this.valueHasChanged = true;
    if (this.multiple) {
      this.toggleOptionSelection(newOption, true);
      this.inputValue = "";
      this.updateFilteredOptions();
      this.setCurrentOption(newOption);
    } else {
      this.setSelectedOptions(newOption);
      this.inputValue = inputValue;
    }
    this.updateComplete.then(() => {
      this.dispatchEvent(new InputEvent("input", { bubbles: true, composed: true }));
      this.dispatchEvent(new Event("change", { bubbles: true, composed: true }));
    });
    if (!this.multiple) {
      this.hide();
      this.comboboxInput.focus({ preventScroll: true });
    }
    return true;
  }
  // Gets visible (filtered) options
  getVisibleOptions() {
    const isUsable = (option) => option.isConnected && !option.disabled;
    if (this.isServerMode) {
      return this.getAllOptions().filter((option) => isUsable(option) && !option.hidden);
    }
    const isFiltering = !!this.inputValue && this.hasInputSinceOpening;
    if (!isFiltering) {
      return this.getAllOptions().filter(isUsable);
    }
    return this.filteredOptions.filter(isUsable);
  }
  // Gets the first visible option
  getFirstVisibleOption() {
    return this.getVisibleOptions()[0];
  }
  // Update the filtered options based on input value. When called from slotchange, skipCreateOption
  // prevents infinite loops (updateCreateOption mutates DOM → triggers slotchange → updateFilteredOptions).
  updateFilteredOptions({ skipCreateOption = false } = {}) {
    const allOptions = this.getAllOptions();
    if (this.isServerMode) {
      this.filteredOptions = allOptions.filter((option) => !option.hidden);
      if (!skipCreateOption) {
        this.updateCreateOption();
      }
      if (this.createOptionEl && !this.createOptionEl.hidden) {
        this.filteredOptions.unshift(this.createOptionEl);
      }
      return;
    }
    const isFiltering = !!this.inputValue && this.hasInputSinceOpening;
    this.querySelectorAll(":scope > :not(wa-option)").forEach((el) => {
      el.hidden = isFiltering;
    });
    if (!isFiltering) {
      this.filteredOptions = allOptions;
      allOptions.forEach((option) => {
        option.hidden = false;
      });
      if (!skipCreateOption) {
        this.updateCreateOption();
      }
      if (this.createOptionEl && !this.createOptionEl.hidden) {
        this.filteredOptions.unshift(this.createOptionEl);
      }
      return;
    }
    const query = this.inputValue.toLowerCase();
    this.filteredOptions = allOptions.filter((option) => {
      if (option.hasAttribute("data-create-option")) {
        return false;
      }
      let matches;
      if (this.filter) {
        matches = this.filter(option, this.inputValue);
      } else {
        matches = option.label.toLowerCase().includes(query);
      }
      option.hidden = !matches;
      return matches;
    });
    this.querySelectorAll(":scope > :not(wa-option):not(wa-divider)").forEach((label) => {
      let hasVisibleOption = false;
      let sibling = label.nextElementSibling;
      while (sibling) {
        if (!sibling.matches("wa-option") && !sibling.matches("wa-divider")) break;
        if (sibling.matches("wa-option") && !sibling.hidden) {
          hasVisibleOption = true;
          break;
        }
        sibling = sibling.nextElementSibling;
      }
      label.hidden = !hasVisibleOption;
    });
    this.querySelectorAll(":scope > wa-divider").forEach((divider) => {
      let hasVisibleBefore = false;
      let hasVisibleAfter = false;
      let sibling = divider.previousElementSibling;
      while (sibling) {
        if (sibling.matches("wa-option") && !sibling.hidden) {
          hasVisibleBefore = true;
          break;
        }
        sibling = sibling.previousElementSibling;
      }
      sibling = divider.nextElementSibling;
      while (sibling) {
        if (sibling.matches("wa-option") && !sibling.hidden) {
          hasVisibleAfter = true;
          break;
        }
        sibling = sibling.nextElementSibling;
      }
      divider.hidden = !hasVisibleBefore || !hasVisibleAfter;
    });
    if (!skipCreateOption) {
      this.updateCreateOption();
    }
    if (this.createOptionEl && !this.createOptionEl.hidden) {
      this.filteredOptions.unshift(this.createOptionEl);
    }
  }
  /**
   * Sets the current option — the one the user is keying through. Deliberately no `aria-activedescendant`: it would
   * live on the shadow-DOM input but name a light-DOM `<wa-option>`, and ARIA id references don't cross shadow
   * boundaries. `announceOption` conveys the active option instead.
   */
  setCurrentOption(option) {
    const allOptions = this.getAllOptions();
    allOptions.forEach((el) => {
      el.current = false;
      el.tabIndex = -1;
    });
    if (option) {
      this.currentOption = option;
      option.current = true;
      option.tabIndex = 0;
      scrollIntoView(option, this.listbox, "vertical", "auto");
    } else {
      this.currentOption = void 0;
    }
  }
  // Sets the selected option(s)
  setSelectedOptions(option) {
    const allOptions = this.getAllOptions();
    const newSelectedOptions = Array.isArray(option) ? option : [option];
    allOptions.forEach((el) => {
      if (newSelectedOptions.includes(el)) {
        return;
      }
      el.selected = false;
    });
    if (newSelectedOptions.length) {
      newSelectedOptions.forEach((el) => el.selected = true);
    }
    this.pruneStandIns();
    this.selectionChanged();
  }
  // Toggles an option's selected state
  toggleOptionSelection(option, force) {
    if (force === true || force === false) {
      option.selected = force;
    } else {
      option.selected = !option.selected;
    }
    this.pruneStandIns();
    this.selectionChanged();
  }
  /**
   * Announces the current option and its position in the list. With no `aria-activedescendant` (see
   * `setCurrentOption`), this is the only way the active option reaches a screen reader, so it must accompany every
   * user-driven change of the current option.
   */
  announceOption(option) {
    const visibleOptions = this.getVisibleOptions();
    this.announce(
      this.localize.term("optionPosition", option.label, visibleOptions.indexOf(option) + 1, visibleOptions.length)
    );
  }
  /**
   * Announces a message politely via the library's shared live region, which lives in the light DOM because a live
   * region inside a shadow root isn't reliably announced (JAWS + Firefox ignores them entirely).
   */
  announce(message) {
    if (!o) announce(message);
  }
  /**
   * What a status state should say: the author's slotted text if there is any, else the localized default. An author
   * who replaces the visible message shouldn't have the default announced to screen reader users instead.
   */
  statusAnnouncement(state) {
    const slotted = [...this.querySelectorAll(`:scope > [slot="${state}"]`)].map((node) => node.textContent ?? "").join(" ").replace(/\s+/g, " ").trim();
    return slotted || this.statusText(state);
  }
  // Announce filter results to screen readers
  announceFilterResults() {
    if (this.loading) return;
    const count = this.getVisibleOptions().length;
    if (count > 0) {
      this.announce(this.localize.term("numOptionsAvailable", count));
    } else {
      this.announce(
        this.statusAnnouncement(this.hasRequestError ? "error" : this.currentQuery ? "no-results" : "empty")
      );
    }
  }
  // @internal This method must be called whenever the selection changes. It will update the selected options cache, the
  // current value, and the display value. The option component uses it internally to update labels as they change.
  selectionChanged() {
    const options = this.getAllOptions();
    const newSelectedOptions = options.filter((el) => {
      if (!this.hasInteracted && !this.valueHasChanged) {
        const defaultValue = this.defaultValue;
        const defaultValues = Array.isArray(defaultValue) ? defaultValue : [defaultValue];
        return el.hasAttribute("selected") || el.defaultSelected || el.selected || defaultValues?.includes(el.value);
      }
      return el.selected;
    });
    const newSelectedValues = new Set(newSelectedOptions.map((el) => el.value));
    for (const value of this.selectionOrder.keys()) {
      if (!newSelectedValues.has(value)) {
        this.selectionOrder.delete(value);
      }
    }
    const maxOrder = this.selectionOrder.size > 0 ? Math.max(...this.selectionOrder.values()) : -1;
    let nextOrder = maxOrder + 1;
    for (const option of newSelectedOptions) {
      if (!this.selectionOrder.has(option.value)) {
        this.selectionOrder.set(option.value, nextOrder++);
      }
    }
    this.selectedOptions = newSelectedOptions.sort((a, b) => {
      const orderA = this.selectionOrder.get(a.value) ?? 0;
      const orderB = this.selectionOrder.get(b.value) ?? 0;
      return orderA - orderB;
    });
    let selectedValues = new Set(this.selectedOptions.map((el) => el.value));
    if (selectedValues.size > 0 || this._value) {
      const oldValue = this._value;
      if (this._value == null) {
        let value = this.defaultValue ?? [];
        this._value = Array.isArray(value) ? value : [value];
      }
      this._value = this._value?.filter((value) => !this.optionValues?.has(value)) ?? null;
      this._value?.unshift(...selectedValues);
      this.requestUpdate("value", oldValue);
    }
    if (!this.multiple && this.selectedOptions.length > 0 && !this.hasInputSinceOpening) {
      const isInputFocused = this.comboboxInput && this.matches(":focus-within");
      if (!this.hasInteracted || !this.inputValue && !isInputFocused) {
        this.inputValue = this.selectedOptions[0].label;
      }
    }
    this.updateComplete.then(() => {
      this.updateValidity();
    });
  }
  get tags() {
    return this.selectedOptions.map((option, index) => {
      if (index < this.maxOptionsVisible || this.maxOptionsVisible <= 0) {
        const tag = this.getTag(option, index);
        if (!tag) return null;
        return typeof tag === "string" ? o3(tag) : tag;
      } else if (index === this.maxOptionsVisible) {
        return x`
          <wa-tag
            part="tag"
            exportparts="
              base:tag__base,
              content:tag__content,
              remove-button:tag__remove-button,
              remove-button__base:tag__remove-button__base
            "
            ?pill=${this.pill}
            size=${this.size}
            >+${this.selectedOptions.length - index}</wa-tag
          >
        `;
      }
      return null;
    });
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    if (changedProperties.has("value") || changedProperties.has("inputValue")) {
      this.customStates.set("blank", !this.value && !this.inputValue);
    }
    if (changedProperties.has("disabled")) {
      this.customStates.set("disabled", this.disabled);
    }
    if (changedProperties.has("loading")) {
      this.customStates.set("loading", this.loading);
    }
    this.customStates.set("showing-loading-row", this.open && this.listboxState === "loading");
  }
  handleDisabledChange() {
    if (this.disabled && this.open) {
      this.open = false;
    }
    if (this.disabled) {
      this.cancelOptionsRequest();
    }
  }
  handleDataSourceChange() {
    if (this.isServerMode) {
      if (this.open) void this.requestOptions({ force: true });
    } else {
      this.cancelOptionsRequest();
      this.hasRequestError = false;
      this.updateFilteredOptions();
    }
  }
  handleLoadingChange() {
    if (this.loading) return;
    clearTimeout(this.loadingAnnounceTimer);
    if (this.isServerMode && !this.dataSource) {
      this.cachedOptions = null;
      this.finishOptionsChange();
    }
  }
  handleValueChange() {
    const allOptions = this.getAllOptions();
    const value = Array.isArray(this.value) ? this.value : [this.value];
    const selectedOptions = allOptions.filter((el) => value.includes(el.value));
    this.setSelectedOptions(selectedOptions);
    this.updateValidity();
  }
  async handleOpenChange() {
    if (this.open && !this.disabled) {
      const openedByTyping = this.isServerMode && this.hasInputSinceOpening;
      if (this.isServerMode && !openedByTyping) {
        void this.requestOptions({ force: true });
      }
      if (openedByTyping) {
        this.setCurrentOption(null);
      } else {
        const selected = this.selectedOptions.find((option) => !option.hasAttribute(STAND_IN_ATTRIBUTE));
        this.setCurrentOption(selected || this.getFirstVisibleOption() || null);
      }
      this.updateFilteredOptions();
      const waShowEvent = new WaShowEvent();
      this.dispatchEvent(waShowEvent);
      if (waShowEvent.defaultPrevented) {
        this.open = false;
        return;
      }
      this.addOpenListeners();
      this.listbox.hidden = false;
      this.popup.active = true;
      requestAnimationFrame(() => {
        if (this.currentOption) {
          this.setCurrentOption(this.currentOption);
        }
      });
      await animateWithClass(this.popup.popup, "show");
      if (this.currentOption) {
        scrollIntoView(this.currentOption, this.listbox, "vertical", "auto");
      }
      if (!this.isServerMode) {
        this.announceFilterResults();
      }
      if (this.currentOption) {
        this.announceOption(this.currentOption);
      }
      this.dispatchEvent(new WaAfterShowEvent());
    } else {
      const waHideEvent = new WaHideEvent();
      this.dispatchEvent(waHideEvent);
      if (waHideEvent.defaultPrevented) {
        this.open = true;
        return;
      }
      this.hasInputSinceOpening = false;
      this.cancelOptionsRequest();
      this.hasRequestError = false;
      this.removeOpenListeners();
      await animateWithClass(this.popup.popup, "hide");
      this.listbox.hidden = true;
      this.popup.active = false;
      this.setCurrentOption(null);
      this.removeCreateOption();
      this.dispatchEvent(new WaAfterHideEvent());
    }
  }
  /** Shows the listbox. */
  async show() {
    if (this.open || this.disabled) {
      this.open = false;
      return void 0;
    }
    if (this.getVisibleOptions().length === 0 && !(this.allowCreate && this.inputValue.trim()) && !this.isServerMode && this.allowCustomValue && this.currentQuery) {
      return void 0;
    }
    this.open = true;
    return waitForEvent(this, "wa-after-show");
  }
  /** Hides the listbox. */
  async hide() {
    if (!this.open || this.disabled) {
      this.open = false;
      return void 0;
    }
    this.open = false;
    return waitForEvent(this, "wa-after-hide");
  }
  /** Sets focus on the control. */
  focus(options) {
    this.comboboxInput.focus(options);
  }
  /** Removes focus from the control. */
  blur() {
    this.comboboxInput.blur();
  }
  formResetCallback() {
    this.selectionOrder.clear();
    this.value = this.defaultValue;
    super.formResetCallback();
    this.handleValueChange();
    if (!this.multiple && this.selectedOptions.length > 0) {
      this.inputValue = this.selectedOptions[0].label;
    } else {
      this.inputValue = "";
    }
    this.updateComplete.then(() => {
      this.dispatchEvent(new InputEvent("input", { bubbles: true, composed: true }));
      this.dispatchEvent(new Event("change", { bubbles: true, composed: true }));
    });
  }
  /**
   * Which listbox status row to render, or `null` when real options are showing. Gated on `hasUpdated` so
   * server-rendered markup is unchanged.
   */
  get listboxState() {
    if (!this.hasUpdated || o) return null;
    if (this.getVisibleOptions().length > 0) return null;
    if (this.loading) return "loading";
    if (this.hasRequestError) return "error";
    return this.currentQuery ? "no-results" : "empty";
  }
  /** The localized default text for a status row. */
  statusText(state) {
    const terms = {
      loading: "loading",
      error: "optionsLoadError",
      "no-results": "noResults",
      empty: "noOptions"
    };
    return this.localize.term(terms[state]);
  }
  render() {
    const listboxState = this.listboxState;
    const hasLabelSlot = this.hasUpdated ? this.hasSlotController.test("label") : this.withLabel;
    const hasHintSlot = this.hasUpdated ? this.hasSlotController.test("hint") : this.withHint;
    const hasLabel = this.label ? true : !!hasLabelSlot;
    const hasHint = this.hint ? true : !!hasHintSlot;
    const hasClearIcon = (this.hasUpdated || o) && this.withClear && !this.disabled && (this.value && (Array.isArray(this.value) ? this.value.length > 0 : true) || this.inputValue);
    return x`
      <div
        part="form-control"
        class=${e2({
      "form-control": true,
      "form-control-has-label": hasLabel
    })}
      >
        <label
          id="label"
          part="form-control-label label"
          class=${e2({
      label: true,
      "has-label": hasLabel
    })}
          aria-hidden=${hasLabel ? "false" : "true"}
          @click=${this.handleLabelClick}
        >
          <slot name="label">${this.label}</slot>
        </label>

        <div part="form-control-input" class="form-control-input">
          <wa-popup
            class=${e2({
      "combobox-popup": true,
      open: this.open,
      disabled: this.disabled,
      enabled: !this.disabled,
      multiple: this.multiple
    })}
            placement=${this.placement}
            flip
            shift
            sync="width"
            auto-size="vertical"
            auto-size-padding="10"
          >
            <div
              part="combobox"
              class="combobox"
              slot="anchor"
              @keydown=${this.handleComboboxKeyDown}
              @mousedown=${this.handleComboboxMouseDown}
              @click=${this.handleComboboxClick}
            >
              <slot part="start" name="start" class="start"></slot>

              ${this.multiple && this.hasUpdated ? x`
                    <div part="tags" class="tags" @wa-remove=${this.handleTagRemove}>
                      ${this.tags}
                      <input
                        part="combobox-input"
                        class="combobox-input"
                        type="text"
                        placeholder=${this.placeholder}
                        .disabled=${this.disabled}
                        .value=${this.inputValue}
                        ?required=${this.required}
                        autocomplete="off"
                        autocapitalize=${o2(this.autocapitalize)}
                        autocorrect=${this.autocorrect ? "on" : "off"}
                        spellcheck=${this.spellcheck}
                        inputmode=${o2(this.inputmode)}
                        enterkeyhint=${o2(this.enterkeyhint)}
                        role="combobox"
                        aria-autocomplete="list"
                        aria-controls=${this.listboxId}
                        aria-expanded=${this.open ? "true" : "false"}
                        aria-haspopup="listbox"
                        aria-labelledby="label"
                        aria-disabled=${this.disabled ? "true" : "false"}
                        aria-describedby="hint"
                        aria-invalid=${!this.validity.valid}
                        tabindex="0"
                        @input=${this.handleInputChange}
                        @compositionstart=${this.handleCompositionStart}
                        @compositionend=${this.handleCompositionEnd}
                        @focus=${this.handleFocus}
                        @blur=${this.handleBlur}
                      />
                    </div>
                  ` : x`
                    <input
                      part="combobox-input"
                      class="combobox-input"
                      type="text"
                      placeholder=${this.placeholder}
                      .disabled=${this.disabled}
                      .value=${this.inputValue}
                      ?required=${this.required}
                      autocomplete="off"
                      autocapitalize=${o2(this.autocapitalize)}
                      autocorrect=${this.autocorrect ? "on" : "off"}
                      spellcheck=${this.spellcheck}
                      inputmode=${o2(this.inputmode)}
                      enterkeyhint=${o2(this.enterkeyhint)}
                      role="combobox"
                      aria-autocomplete="list"
                      aria-controls=${this.listboxId}
                      aria-expanded=${this.open ? "true" : "false"}
                      aria-haspopup="listbox"
                      aria-labelledby="label"
                      aria-disabled=${this.disabled ? "true" : "false"}
                      aria-describedby="hint"
                      aria-invalid=${!this.validity.valid}
                      tabindex="0"
                      @input=${this.handleInputChange}
                      @compositionstart=${this.handleCompositionStart}
                      @compositionend=${this.handleCompositionEnd}
                      @focus=${this.handleFocus}
                      @blur=${this.handleBlur}
                    />
                  `}

              <input
                class="value-input"
                type="text"
                ?disabled=${this.disabled}
                ?required=${this.required}
                .value=${Array.isArray(this.value) ? this.value.join(", ") : this.value ?? ""}
                tabindex="-1"
                aria-hidden="true"
                @focus=${() => this.focus()}
              />

              ${hasClearIcon ? x`
                    <button
                      part="clear-button"
                      type="button"
                      aria-label=${this.localize.term("clearEntry")}
                      @mousedown=${this.handleClearMouseDown}
                      @click=${this.handleClearClick}
                      tabindex="-1"
                    >
                      <slot name="clear-icon">
                        <wa-icon name="circle-xmark" library="system" variant="regular"></wa-icon>
                      </slot>
                    </button>
                  ` : E}

              <slot name="end" part="end" class="end"></slot>

              <!-- The spinner is overlaid on the expand icon's box so swapping between them shifts nothing. -->
              <div class="trailing-affordance">
                <slot name="expand-icon" part="expand-icon" class="expand-icon">
                  <wa-icon library="system" name="chevron-down" variant="solid"></wa-icon>
                </slot>
                ${this.hasUpdated && !o ? x`<wa-spinner part="spinner" class="spinner" aria-hidden="true"></wa-spinner>` : E}
              </div>
            </div>

            <div part="listbox" class="listbox">
              <div
                id=${this.listboxId}
                role="listbox"
                aria-expanded=${this.open ? "true" : "false"}
                aria-multiselectable=${this.multiple ? "true" : "false"}
                aria-labelledby="label"
                aria-busy=${this.loading ? "true" : "false"}
                class="listbox-options"
                tabindex="-1"
                @mouseup=${this.handleOptionClick}
              >
                <slot @slotchange=${this.handleDefaultSlotChange}></slot>
              </div>

              <!-- Outside the listbox element, so a role="listbox" never contains non-option children, but inside
                   the popup so they read as part of it. -->
              ${listboxState ? x`
                    <div part="status ${listboxState}" class="status">
                      ${listboxState === "loading" ? x`<slot name="loading">
                            <!-- Hidden from AT: wa-spinner is a role="progressbar" labelled "Loading", which would
                                 be read alongside the visible "Loading" text right next to it. -->
                            <wa-spinner class="status-spinner" aria-hidden="true"></wa-spinner>
                            <span>${this.statusText("loading")}</span>
                          </slot>` : x`<slot name=${listboxState}>${this.statusText(listboxState)}</slot>`}
                    </div>
                  ` : E}
            </div>
          </wa-popup>
        </div>

        <slot
          id="hint"
          name="hint"
          part="hint"
          class=${e2({
      "has-slotted": hasHint
    })}
          aria-hidden=${hasHint ? "false" : "true"}
          >${this.hint}</slot
        >
      </div>
    `;
  }
};
WaCombobox.css = [combobox_styles_default, form_control_styles_default, size_styles_default];
__decorateClass([
  r()
], WaCombobox.prototype, "hasRequestError", 2);
__decorateClass([
  e(".combobox-popup")
], WaCombobox.prototype, "popup", 2);
__decorateClass([
  e(".combobox")
], WaCombobox.prototype, "combobox", 2);
__decorateClass([
  e(".combobox-input")
], WaCombobox.prototype, "comboboxInput", 2);
__decorateClass([
  e(".value-input")
], WaCombobox.prototype, "valueInput", 2);
__decorateClass([
  e(".listbox")
], WaCombobox.prototype, "listbox", 2);
__decorateClass([
  r()
], WaCombobox.prototype, "selectedOptions", 2);
__decorateClass([
  r()
], WaCombobox.prototype, "filteredOptions", 2);
__decorateClass([
  r()
], WaCombobox.prototype, "inputValue", 2);
__decorateClass([
  n({ reflect: true })
], WaCombobox.prototype, "name", 2);
__decorateClass([
  n({
    attribute: false
  })
], WaCombobox.prototype, "defaultValue", 1);
__decorateClass([
  n({ attribute: "value", reflect: false })
], WaCombobox.prototype, "value", 1);
__decorateClass([
  n({ reflect: true })
], WaCombobox.prototype, "size", 2);
__decorateClass([
  watch("size")
], WaCombobox.prototype, "handleSizeChange", 1);
__decorateClass([
  n()
], WaCombobox.prototype, "placeholder", 2);
__decorateClass([
  n({ type: Boolean, reflect: true })
], WaCombobox.prototype, "multiple", 2);
__decorateClass([
  n({ attribute: "max-options-visible", type: Number })
], WaCombobox.prototype, "maxOptionsVisible", 2);
__decorateClass([
  n({ type: Boolean })
], WaCombobox.prototype, "disabled", 2);
__decorateClass([
  n({ attribute: "with-clear", type: Boolean })
], WaCombobox.prototype, "withClear", 2);
__decorateClass([
  n({ type: Boolean, reflect: true })
], WaCombobox.prototype, "open", 2);
__decorateClass([
  n({ reflect: true })
], WaCombobox.prototype, "appearance", 2);
__decorateClass([
  n({ type: Boolean, reflect: true })
], WaCombobox.prototype, "pill", 2);
__decorateClass([
  n()
], WaCombobox.prototype, "label", 2);
__decorateClass([
  n({ reflect: true })
], WaCombobox.prototype, "placement", 2);
__decorateClass([
  n({ attribute: "hint" })
], WaCombobox.prototype, "hint", 2);
__decorateClass([
  n({ attribute: "with-label", type: Boolean })
], WaCombobox.prototype, "withLabel", 2);
__decorateClass([
  n({ attribute: "with-hint", type: Boolean })
], WaCombobox.prototype, "withHint", 2);
__decorateClass([
  n({ type: Boolean, reflect: true })
], WaCombobox.prototype, "required", 2);
__decorateClass([
  n({ attribute: "allow-custom-value", type: Boolean })
], WaCombobox.prototype, "allowCustomValue", 2);
__decorateClass([
  n({ attribute: "allow-create", type: Boolean })
], WaCombobox.prototype, "allowCreate", 2);
__decorateClass([
  n({ attribute: false })
], WaCombobox.prototype, "filter", 2);
__decorateClass([
  n({ attribute: false })
], WaCombobox.prototype, "dataSource", 2);
__decorateClass([
  n({ type: Boolean, reflect: true })
], WaCombobox.prototype, "server", 2);
__decorateClass([
  n({ type: Boolean, reflect: true })
], WaCombobox.prototype, "loading", 2);
__decorateClass([
  n({ attribute: "filter-debounce", type: Number })
], WaCombobox.prototype, "filterDebounce", 2);
__decorateClass([
  n()
], WaCombobox.prototype, "autocapitalize", 2);
__decorateClass([
  n({
    type: Boolean,
    converter: {
      fromAttribute: (value) => !value || value === "off" ? false : true,
      toAttribute: (value) => value ? "on" : "off"
    }
  })
], WaCombobox.prototype, "autocorrect", 2);
__decorateClass([
  n()
], WaCombobox.prototype, "inputmode", 2);
__decorateClass([
  n()
], WaCombobox.prototype, "enterkeyhint", 2);
__decorateClass([
  n({
    type: Boolean,
    converter: {
      // Allow "true|false" attribute values but keep the property boolean
      fromAttribute: (value) => !value || value === "false" ? false : true,
      toAttribute: (value) => value ? "true" : "false"
    }
  })
], WaCombobox.prototype, "spellcheck", 2);
__decorateClass([
  n({ attribute: false })
], WaCombobox.prototype, "getTag", 2);
__decorateClass([
  watch("disabled", { waitUntilFirstUpdate: true })
], WaCombobox.prototype, "handleDisabledChange", 1);
__decorateClass([
  watch(["dataSource", "server"], { waitUntilFirstUpdate: true })
], WaCombobox.prototype, "handleDataSourceChange", 1);
__decorateClass([
  watch("loading", { waitUntilFirstUpdate: true })
], WaCombobox.prototype, "handleLoadingChange", 1);
__decorateClass([
  watch("value", { waitUntilFirstUpdate: true })
], WaCombobox.prototype, "handleValueChange", 1);
__decorateClass([
  watch("open", { waitUntilFirstUpdate: true })
], WaCombobox.prototype, "handleOpenChange", 1);
WaCombobox = __decorateClass([
  t("wa-combobox")
], WaCombobox);

export {
  WaCombobox
};
